import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { authColors } from "../../../styles/authTokens";

/**
 * Auth-flow styling — `authColors`, `rem` sizing, 1px hairline borders only.
 * See `TenantSelectRow.styles.ts` for why this uses `authColors` rather than
 * the app-wide `rawColors`.
 */

/**
 * `max-height` is a PLACEHOLDER pending the design spec. Confirm against Figma.
 *
 * The value deliberately lands PART-WAY through a row (~3.5 rows at the
 * measured 4.3rem row pitch) rather than on a boundary. Cutting cleanly after
 * a whole row makes an overflowing list look complete — the user gets no hint
 * that more tenants exist below. A sliver of the next row is the affordance.
 */
export const List = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  max-height: 15rem;
  overflow-y: auto;
  /* Keeps the focus ring on the last row from being clipped by the scroller. */
  padding: 0.125rem;
`;

export const StatusText = styled.p`
  ${typographyMixin("caption", 4)}
  color: ${authColors.textMedEmphasis};
  margin: 0;
  width: 100%;
  text-align: center;
  padding: 1rem 0;
`;

export const ErrorText = styled(StatusText)`
  color: ${authColors.error};
  padding-bottom: 0.5rem;
`;

export const RetryButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  ${typographyMixin("caption", 3)}
  color: ${authColors.buttonPrimary};
  display: block;
  margin: 0 auto;

  &:hover {
    text-decoration: underline;
  }
`;

/** Neutral placeholder rows so the step does not flash empty while loading. */
export const SkeletonRow = styled.div`
  width: 100%;
  height: 3.25rem;
  border-radius: 0.5rem;
  border: 1px solid ${authColors.inputBorder};
  background: ${authColors.white};
  opacity: 0.6;
`;
